module.exports = function($) {
  var PlaceholderField, defaultPromptEnabled, inputEmpty, setPlaceholder;
  PlaceholderField = $.fn.PlaceholderField = function() {
    if (PlaceholderField.hasNativePlaceholderSupport()) {
      return this;
    }
    return this.each(function() {
      return PlaceholderField.initPlaceholder($(this));
    });
  };
  PlaceholderField.hasNativePlaceholderSupport = function() {
    return _.all([document.createElement('input'), document.createElement('textarea')], function(elem) {
      return elem.placeholder != null;
    });
  };
  inputEmpty = function($input) {
    return /^\s*$/.test($input.val());
  };
  PlaceholderField.initPlaceholder = function($input) {
    var focusin, focusout;
    focusin = function() {
      if (defaultPromptEnabled($input)) {
        return $input.val('').removeClass('prompting');
      }
    };
    (focusout = function() {
      if (inputEmpty($input)) {
        return setPlaceholder($input);
      }
    })();
    return $input.on({
      focusin: focusin,
      focusout: focusout
    });
  };
  setPlaceholder = function($input) {
    var ref;
    $input.addClass('prompting');
    return $input.val((ref = $input.attr('placeholder')) != null ? ref : $input.attr('title'));
  };
  defaultPromptEnabled = function($input) {
    var placeholder, sansWhitespace;
    sansWhitespace = function(val) {
      return val.replace(/\s/g, '');
    };
    placeholder = $input.attr('placeholder') || $input.attr('title') || '';
    return sansWhitespace($input.val()) === sansWhitespace(placeholder);
  };
  return PlaceholderField;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3BsYWNlaG9sZGVyX2ZpZWxkLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9wbGFjZWhvbGRlcl9maWVsZC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsU0FBQyxDQUFEO0FBQ2YsTUFBQTtFQUFBLGdCQUFBLEdBQW1CLENBQUMsQ0FBQyxFQUFFLENBQUMsZ0JBQUwsR0FBd0IsU0FBQTtJQUN6QyxJQUFlLGdCQUFnQixDQUFDLDJCQUFqQixDQUFBLENBQWY7QUFBQSxhQUFPLEtBQVA7O1dBRUEsSUFBQyxDQUFBLElBQUQsQ0FBTSxTQUFBO2FBQUcsZ0JBQWdCLENBQUMsZUFBakIsQ0FBaUMsQ0FBQSxDQUFFLElBQUYsQ0FBakM7SUFBSCxDQUFOO0VBSHlDO0VBSzNDLGdCQUFnQixDQUFDLDJCQUFqQixHQUErQyxTQUFBO1dBQzdDLENBQUMsQ0FBQyxHQUFGLENBQU0sQ0FDSixRQUFRLENBQUMsYUFBVCxDQUF1QixPQUF2QixDQURJLEVBRUosUUFBUSxDQUFDLGFBQVQsQ0FBdUIsVUFBdkIsQ0FGSSxDQUFOLEVBR0csU0FBQyxJQUFEO2FBQVU7SUFBVixDQUhIO0VBRDZDO0VBTS9DLFVBQUEsR0FBYSxTQUFDLE1BQUQ7V0FBWSxPQUFPLENBQUMsSUFBUixDQUFhLE1BQU0sQ0FBQyxHQUFQLENBQUEsQ0FBYjtFQUFaO0VBRWIsZ0JBQWdCLENBQUMsZUFBakIsR0FBbUMsU0FBQyxNQUFEO0FBQ2pDLFFBQUE7SUFBQSxPQUFBLEdBQVUsU0FBQTtNQUNSLElBQTJDLG9CQUFBLENBQXFCLE1BQXJCLENBQTNDO2VBQUEsTUFBTSxDQUFDLEdBQVAsQ0FBVyxFQUFYLENBQWMsQ0FBQyxXQUFmLENBQTJCLFdBQTNCLEVBQUE7O0lBRFE7SUFHUCxDQUFBLFFBQUEsR0FBVyxTQUFBO01BQ1osSUFBMEIsVUFBQSxDQUFXLE1BQVgsQ0FBMUI7ZUFBQSxjQUFBLENBQWUsTUFBZixFQUFBOztJQURZLENBQVgsQ0FBSCxDQUFBO1dBR0EsTUFBTSxDQUFDLEVBQVAsQ0FBVTtNQUFDLFNBQUEsT0FBRDtNQUFVLFVBQUEsUUFBVjtLQUFWO0VBUGlDO0VBU25DLGNBQUEsR0FBaUIsU0FBQyxNQUFEO0FBQ2YsUUFBQTtJQUFBLE1BQU0sQ0FBQyxRQUFQLENBQWdCLFdBQWhCO1dBQ0EsTUFBTSxDQUFDLEdBQVAsb0RBQXdDLE1BQU0sQ0FBQyxJQUFQLENBQVksT0FBWixDQUF4QztFQUZlO0VBSWpCLG9CQUFBLEdBQXVCLFNBQUMsTUFBRDtBQUNyQixRQUFBO0lBQUEsY0FBQSxHQUFpQixTQUFDLEdBQUQ7YUFBUyxHQUFHLENBQUMsT0FBSixDQUFZLEtBQVosRUFBbUIsRUFBbkI7SUFBVDtJQUNqQixXQUFBLEdBQWMsTUFBTSxDQUFDLElBQVAsQ0FBWSxhQUFaLENBQUEsSUFBOEIsTUFBTSxDQUFDLElBQVAsQ0FBWSxPQUFaLENBQTlCLElBQXNEO1dBQ3BFLGNBQUEsQ0FBZSxNQUFNLENBQUMsR0FBUCxDQUFBLENBQWYsQ0FBQSxLQUFnQyxjQUFBLENBQWUsV0FBZjtFQUhYO1NBS3ZCO0FBaENlIn0=
